import { Box, Button, Tooltip } from '@mui/material'
import { pdf } from '@react-pdf/renderer'
import React from 'react'
import downLoadGray from '../../../assets/images/common/downloadGray.svg'
import downLoad from '../../../assets/images/common/downloadWhite.svg'
import DealerRequestPDF from '../../../views/RequestsManagement/components/DealerRecuestPDF/DealerRecuestPDF'
import { useRequestsTableData } from '../../../views/RequestsManagement/components/NewRequestsTable/hooks/useNewRequestsTableData'
import { btnStyles, popperStyles } from '../styles/downloadButtonStyles'

const popperProps = {
  sx: popperStyles,
}

const DownloadButton = ({ disabled, paginationStore, checkboxStore }) => {
  const { data } = useRequestsTableData(paginationStore)
  const { selectedIds } = checkboxStore

  const selectedOrders =
    data?.content.filter((el) => selectedIds.includes(el.id)) ?? []

  const downloadRequestsListPDF = async () => {
    const minOrderId = Math.min(...selectedOrders.map((order) => order.id))
    const maxOrderId = Math.max(...selectedOrders.map((order) => order.id))
    const date = new Date().toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const filename = `${date}_${minOrderId}-${maxOrderId}.pdf`
    const createPDF = pdf(<DealerRequestPDF data={selectedOrders} />).toBlob()

    createPDF.then((blob) => {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    })
  }

  return disabled ? (
    <Tooltip
      title={'выберите заявки для возможности выгрузить список заявок'}
      placement={'top'}
      PopperProps={popperProps}
    >
      <Box>
        <Button
          variant='contained'
          id={'newFiltersButton1'}
          color='primary'
          sx={btnStyles}
          startIcon={<img src={downLoadGray} alt='Download Icon' />}
          disabled
        />
      </Box>
    </Tooltip>
  ) : (
    <Button
      variant='contained'
      id={'newFiltersButton1'}
      color='primary'
      onClick={downloadRequestsListPDF}
      sx={btnStyles}
      startIcon={<img src={downLoad} alt='Download Icon' />}
    />
  )
}

export default DownloadButton
